import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {OrganizationPersistRequest} from "../model/requests/organization-persist-request";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OrganizationsService {

  private readonly organizationURL: string;


  constructor(private http: HttpClient) {
    this.organizationURL = '/api/organizations';
  }

  public getOrganizations(): Observable<any> {
    return this.http.get<any>(this.organizationURL);
  }

  public getOrganizationsSummary(): Observable<any> {
    const url: string = `${this.organizationURL}/summary`;
    return this.http.get<any>(url);
  }

  public getOrganization(organizationUuid: string): Observable<any> {
    const url: string = `${this.organizationURL}/${organizationUuid}`;
    return this.http.get<any>(url);
  }

  public createOrganization(organizationData: OrganizationPersistRequest): Observable<any> {
    return this.http.post<any>(this.organizationURL, organizationData);
  }

  public editOrganization(organizationData: OrganizationPersistRequest): Observable<any> {
    const url: string = `${this.organizationURL}/${organizationData.organizationUuid}`;
    return this.http.put<any>(url, organizationData);
  }

  public deleteOrganization(organizationUuid: string): Observable<HttpResponse<any>> {
    const url: string = `${this.organizationURL}/${organizationUuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

}
